import FormFieldsComponent, {
	FormFieldsComponentProps,
	FormFieldTypes,
} from './FormFieldsComponent';
export type { FormFieldsComponentProps };
export { FormFieldTypes };
export default FormFieldsComponent;
